import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { logError } from 'services/logging/logging';
import { ErrorPage } from 'components/Page/ErrorPage';

export const MainErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      logError(error, {
        tags: { error_boundary: 'main_route' },
        extra: { location: window.location.href },
      });
    }
  }, [error]);

  return <ErrorPage />;
};
